<template>
  <app-layout title="Customize">
    <template #header>
      <div class="flex h-9">
        <h2
          class="flex-1 font-semibold text-xl leading-tight flex items-center"
        >
          {{ project.domain_name }}
        </h2>
      </div>
    </template>

    <div class="mx-auto sm:px-6 lg:px-8">
      <div
        class="
          text-sm
          font-medium
          text-center text-yr-primary-ii-500
          border-b-xx border-gray-200-xx
        "
      >
        <ul class="flex flex-wrap -mb-px">
          <li
            v-for="(tabContent, index) in tabsContent"
            :key="index"
            class="mr-2"
          >
            <Link
              :href="route(`projects.${tabContent.link}.index`, project)"
              class="inline-block p-4 rounded-t-lg border-b-[3px]"
              :class="
                tabContent.link === lastPath
                  ? 'font-bold text-yr-primary-ii-700 border-yr-primary-ii-700'
                  : 'border-transparent hover:border-yr-primary-ii-400'
              "
              >{{ tabContent.title }}</Link
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="pb-12">
      <div class="mx-auto sm:px-6 lg:px-8">
        <div
          class="
            p-6
            sm:px-8
            bg-white
            overflow-hidden
            shadow-xl
            sm:rounded-lg
            grid grid-cols-4
            gap-4
          "
        >
          <div class="col-span-1">
            <jet-button
              v-for="(menuCategory, index) in menuCategories"
              :key="index"
              class="
                flex
                justify-between
                w-full
                px-4
                py-4
                mb-3
                text-yr-primary-ii-500
                border-yr-primary-ii-300
                hover:bg-yr-primary-500 hover:border-yr-primary-500
                active:bg-yr-primary-600
                focus:outline-none
                focus:border-yr-primary-500
                focus:ring-transparent
                transition
              "
              :class="
                index === 0
                  ? 'bg-yr-primary-500 border-yr-primary-500'
                  : 'bg-transparent'
              "
            >
              <span>{{ menuCategory }}</span>
              <!-- <span class="material-icons md-16">keyboard_arrow_down</span> -->
            </jet-button>
          </div>
          <div class="col-span-3 border-l border-yr-primary-ii-200 pl-4">
            <div class="py-0">
              <div class="flex justify-between">
                <p class="font-bold">รูปแบบของแบนเนอร์</p>
                <div class="inline-flex text-yr-primary-ii-500 cursor-pointer">
                  <div>
                    <span
                      class="
                        text-sm
                        mx-5
                        cursor-pointer
                        hover:underline
                        text-gray-500
                        hover:text-gray-700
                      "
                    >
                      ยกเลิกการเปลี่ยนแปลง
                    </span>
                    <jet-button
                      class="
                        cursor-pointer
                        inline-flex
                        items-center
                        px-4
                        py-2
                        bg-yr-primary-ii-500
                        border border-transparent
                        rounded-md
                        font-semibold
                        text-xs text-white
                        uppercase
                        tracking-widest
                        hover:bg-yr-primary-ii-600
                        active:bg-yr-primary-ii-700
                        focus:outline-none
                        focus:border-yr-primary-ii-700
                        focus:ring
                        focus:ring-yr-primary-ii-300
                        transition
                      "
                    >
                      บันทึก
                    </jet-button>
                  </div>
                </div>
              </div>
              <div class="form-check pb-4">
                <input
                  class="
                    form-check-input
                    appearance-none
                    rounded-full
                    h-4
                    w-4
                    border border-gray-300
                    bg-white
                    hover:border-gray-300
                    checked:bg-yr-primary-500
                    checked:border-yr-primary-500
                    checked:focus:bg-yr-primary-500
                    checked:hover:bg-yr-primary-500
                    focus:border-yr-primary-500 focus:ring-0
                    transition
                    duration-200
                    mt-1
                    align-top
                    bg-no-repeat bg-center bg-contain
                    float-left
                    mr-2
                    cursor-pointer
                  "
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  class="
                    form-check-label
                    inline-block
                    text-gray-800
                    font-bold
                    text-yr-primary-ii-500
                  "
                  for="flexRadioDefault1"
                >
                  Default
                  <span class="text-sm text-yr-primary-700"> (Recommend) </span>
                </label>
                <div class="description">
                  <p class="text-sm text-yr-primary-iii-900 ml-6">
                    หากคุณเลือกรูปแบบของแบนเนอร์เป็น 'Default' (รูปแบบเริ่มต้น)
                    คุกกี้ทุกหมวดหมู่ยกเว้นคุกกี้ที่จำเป็นจะถูกตั้งค่าให้รูปแบบของการให้ความยินยอมเป็น
                    'แจ้งรับ'<br />
                    (opt-in) กล่าวคือคุกกี้หมวดหมู่นั้นจะถูกบล็อกโดย Cookie Pop
                    ไม่ให้ทำงานก่อนที่จะได้รับความยินยอมจากผู้เยี่ยมชมเว็บไซต์
                    และผู้เยี่ยมชมเว็บไซต์จะสามารถเลือกเปิดหรือปิดหมวดหมู่คุกกี้ต่าง
                    ๆ ได้ในเมนูการตั้งค่าคุกกี้ (Preference center)
                    บนแบนเนอร์คุกกี้
                    โดยที่คุณสามารถตั้งค่ารูปแบบของการให้ความยินยอมในแต่ละหมวดหมู่ได้ในภายหลังที่เมนู
                    จัดการคุกกี้
                  </p>
                </div>
              </div>
              <div class="form-check pb-4">
                <input
                  class="
                    form-check-input
                    appearance-none
                    rounded-full
                    h-4
                    w-4
                    border border-gray-300
                    bg-white
                    hover:border-gray-300
                    checked:bg-yr-primary-500
                    checked:border-yr-primary-500
                    checked:focus:bg-yr-primary-500
                    checked:hover:bg-yr-primary-500
                    focus:border-yr-primary-500 focus:ring-0
                    transition
                    duration-200
                    mt-1
                    align-top
                    bg-no-repeat bg-center bg-contain
                    float-left
                    mr-2
                    cursor-pointer
                  "
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                />
                <label
                  class="
                    form-check-label
                    inline-block
                    text-gray-800
                    font-bold
                    text-yr-primary-ii-500
                  "
                  for="flexRadioDefault2"
                >
                  Notice Only
                </label>
                <div class="description">
                  <p class="text-sm text-yr-primary-iii-900 ml-6">
                    หากคุณเลือกรูปแบบของแบนเนอร์เป็น 'Notice Only'
                    (แจ้งให้ทราบเท่านั้น)
                    คุกกี้ในทุกหมวดหมู่จะถูกอนุญาตให้ทำงานทันทีที่ผู้เยี่ยมชมเว็บไซต์เข้ามาที่เว็บไซต์<br />
                    และผู้เยี่ยมชมเว็บไซต์จะไม่สามารถปิดการทำงานของคุกกี้ได้
                  </p>
                </div>
              </div>
              <div
                class="
                  col-span-12
                  px-6
                  py-3
                  rounded
                  border border-red-500
                  bg-red-50
                "
              >
                <p class="font-medium text-sm text-red-500">
                  <span class="font-bold text-base">คำเตือน </span>
                  <span class="material-icons md-16 relative top-0.5"
                    >info_outline</span
                  >
                  <br />
                  คำเตือน Cookie Pop (“ผู้ให้บริการ“)
                  ขอแนะนำเป็นอย่างยิ่งให้ท่านทำการตรวจสอบก่อนเริ่มใช้งานว่ารูปแบบของแบนเนอร์คุกกี้เพื่อการขอความยินยอมที่ท่านได้เลือกใช้นั้นสามารถใช้ได้และเป็นไปตามกฎหมายหรือไม่
                  ทั้งนี้
                  ทางผู้ให้บริการไม่มีหน้าที่รับผิดชอบต่อความเสียหายที่อาจเกิดขึ้นหากการเลือกใช้รูปแบบของแบนเนอร์คุกกี้โดยท่านไม่เป็นไปตามที่กฎหมายกำหนด
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import moment from "moment";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import { Link } from "@inertiajs/inertia-vue3";
import ToggleButton from "@/Components/ToggleButton";
import "tw-elements";

export default defineComponent({
  props: ["project"],

  components: {
    AppLayout,
    Link,
    JetButton,
    JetInput,
    ToggleButton,
  },

  data() {
    return {
      tabsContent: [
        {
          title: "บันทึกความยินยอม",
          link: "consents",
        },
        {
          title: "สแกนคุกกี้",
          link: "cookies",
        },
        {
          title: "จัดการคุกกี้",
          link: "manage",
        },
        {
          title: "ปรับแต่งแบนเนอร์",
          link: "dialogs",
        },
        // {
        //   title: "ตั้งค่าแบนเนอร์",
        //   link: "banner_setting",
        // },
      ],
      menuCategories: ["รูปแบบของแบนเนอร์", "ตั้งค่าการแสดงผลแบนเนอร์"],
    };
  },

  computed: {
    lastPath() {
      return window.location.pathname.split("/").pop();
    },
  },

  methods: {
    getHumanDate(date) {
      return moment(date).format("YYYY-MM-DD  h:mm");
    },
  },
});
</script>
